import { Directive, HostListener, inject } from '@angular/core';
import { Select } from 'primeng/select';

@Directive({
  selector: '[appResetDropdownFilter]',
  standalone: true,
})
export class ResetDropdownFilterDirective {
  private readonly dropdown = inject(Select, { optional: true });

  constructor() {
    const dropdown = this.dropdown;

    if (!dropdown) {
      throw new Error('ResetDropdownFilterDirective must be used on a p-dropdown component.');
    }
  }

  @HostListener('onShow')
  resetFilter() {
    if (this.dropdown) {
      this.dropdown.filterValue = '';
      this.dropdown.resetFilter();
    }
  }
}
